import { Component } from "react";
// import { Table, SecondaryButton, InputLabel } from '@ttd/lingo';

import { Table, Button } from 'antd';

import PropTypes from 'prop-types';

class BucketsList extends Component {
  constructor() {
    super();
    this.state = {
      filteredInfo: {}
    };

    // this.handlePagination = this.handlePagination.bind(this);
    // this.handleSortFilter = this.handleSortFilter.bind(this);
  }

  // handlePagination(page) {
  //   dispatch(PaginateData(page));
  // }

  // handleSortFilter(params) {
  //   dispatch(SortFilterData(params));
  // }

  render() {
    let buckets_list = this.props.buckets_list;
    let project_filters = [];
    let bucket_filters = [];

    if (buckets_list !== null && buckets_list.length > 0) {
      buckets_list.forEach((element, index) => {
        project_filters.push({ 'text': element["Project"], 'value': element["Project"] });
        bucket_filters.push({ 'text': element["Bucket"], 'value': element["Bucket"] });
        element["index"] = index
      });

    }


    return (
      <div>

        <Table
          columns={[
            {
              dataIndex: 'Project',
              title: 'Project',
              sorter: (a, b) => a["Project"].localeCompare(b["Project"]),
              // onFilter: (value, record) => record.Project.startsWith(value),
              // filters: project_filters,
              // filterSearch: true,
            },
            {
              dataIndex: 'Bucket',
              title: 'Bucket',
              sorter: (a, b) => a["Bucket"].localeCompare(b["Bucket"]),
              // onFilter: (value, record) => record.Bucket.startsWith(value),
              // filters: bucket_filters,
              // filterSearch: true,
            },
            {
              dataIndex: 'Region',
              title: 'Region',
              sorter: (a, b) => a["Region"].localeCompare(b["Region"]),
              // onFilter: (value, record) => record.Bucket.startsWith(value),
              // filters: bucket_filters,
              // filterSearch: true,
            },
            {
              title: 'Folders',
              render: (bucket) => <div className="folders">{bucket.Folders.map(b =>
                <div key={b.PathPrefix}><p><span>{b.DisplayName} ({bucket.Bucket} -&gt; {b.PathPrefix})</span><span>{b.Users.map(u => u.Email).join(", ")}</span></p></div>)}</div>,
            },

            {
              title: 'Actions',
              render: (bucket) => <div>
                <Button
                  as="button"
                  className="btn-space"
                  onClick={() => this.props.editBucket(bucket)}>
                  Edit
                </Button>
              </div>
            },
          ]}
          data-ttd-inspect-id="bucket_list_table"
          dataSource={buckets_list}
          rowKey="index"
          pagination={false}
          className="bucket_list"
          rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
        />
      </div>
    );
  }
}

BucketsList.propTypes = {
    buckets_list: PropTypes.any,
    editBucket: PropTypes.func,
};

export default BucketsList;
